import React, { Component } from 'react'
import { connect } from 'react-redux'
import moment from 'moment'
import PropTypes from 'prop-types'
import trans from 'counterpart'
import DatePicker from './DatePicker'
import { getArrival, getDeparture } from '../../../preferences/selectors'
import { getFilter } from '../../../../selectors/filterSelectors'
import { setArrivalPreference } from '../../../../actions/preferenceActions'
import { INTERNAL_DATE } from '../../../../constants/dates'

class ArrivalDatePicker extends Component {
  state = {
    dropdown: false,
    monthBlocked: false
  }

  componentDidMount = () => {
    document.addEventListener('mousedown', this.handleClickOutside)
  }

  componentWillUnmount = () => {
    document.removeEventListener('mousedown', this.handleClickOutside)
  }

  handleClickOutside = (event) => {
    if (this.picker && this.state.dropdown && !this.picker.contains(event.target)) {
      this.toggle()
    }
  }

  toggle = () => this.setState(prevState => ({
    dropdown: !prevState.dropdown
  }));

  getFutureReservationsRoute = () => {
    if (process.env.RAZZLE_APP === 'dierenbos') {
      return trans('routes.reserve_dierenbos')
    }

    return trans('routes.reserve')
  }

  render = () => {
    const { arrival, onChange, end, availableDates, setArrivalDate, toggle } = this.props

    return (
      <div className={`arrival-date form-dropdown form-arrival dropdown ${this.state.dropdown ? 'show' : ''} `} ref={(ref) => { this.picker = ref }}>
        <div className='dropdown-toggle' onClick={this.toggle}>
          <div className='dropdown-filter'>
            <div className='dropdown-heading'>{trans('label.arrival_date')}</div>
            <div className='dropdown-value'>
              {moment(arrival).format('DD-MM-YYYY')}
            </div>
          </div>
        </div>

        {this.state.dropdown && (
          <div className={`dropdown-menu${this.state.monthBlocked ? ' future-date' : ''}`}>
            <DatePicker
              availableDates={availableDates}
              start={arrival}
              end={end}
              date={arrival}
              onDateClick={(date) => {
                setArrivalDate(date)
                onChange(date)
                if (toggle) toggle('openDeparture', true)
                this.setState({
                  dropdown: false
                })
              }}
              onMonthChange={(date) => {
                if (date > moment('2022-01-31')) {
                  return this.setState({ monthBlocked: true })
                }
                return this.setState({ monthBlocked: false })
              }}
            />
            <div className='future-booking'>
              <div>
                <p>
                  {trans('label.future_booking')}
                </p>
                <p>{trans('label.future_booking_two')}</p>
                <a className='btn btn-mail' href={this.getFutureReservationsRoute()}>{trans('label.book')}</a>
              </div>
            </div>
          </div>
        )}
      </div>
    )
  }
}

ArrivalDatePicker.defaultProps = {
  onChange: () => {}
}

ArrivalDatePicker.propTypes = {
  arrival: PropTypes.string,
  onChange: PropTypes.func,
  end: PropTypes.string,
  setArrivalDate: PropTypes.func,
  availableDates: PropTypes.array,
  toggle: PropTypes.func
}

const mapStateToProps = state => ({
  arrival: getArrival(state),
  availableDates: getFilter('arrivals')(state),
  end: getDeparture(state)
})

const mapDispatchToProps = dispatch => ({
  setArrivalDate: date => dispatch(setArrivalPreference(date.format(INTERNAL_DATE)))
})

export default connect(mapStateToProps, mapDispatchToProps)(ArrivalDatePicker)
